import * as C from '../constants';
import xmlBook from '../../../services/xml-twenty-book';

export default {
  getSchedules({ commit }) {
    commit(C.SCHEDULES_PENDING);
    return xmlBook.getSchedules().then((res) => {
      commit(C.SCHEDULES_SUCCESS, res.data);
    }).catch(() => {
      commit(C.SCHEDULES_FAILURE);
    });
  },
  setScheduleSearch({ commit }, payload) {
    commit(C.SCHEDULES_SEARCH, payload);
  },
  postSchedules({ commit }, payload) {
    commit(C.SCHEDULES_POST_PENDING);
    return xmlBook.postSchedules(payload).then((res) => {
      commit(C.SCHEDULES_POST_SUCCESS, res.data);
    }).catch((res) => {
      commit(C.SCHEDULES_POST_FAILURE, res.response.data.data);
    });
  },
  setEditSchedule({ commit }, payload) {
    commit(C.SCHEDULE_EDIT, payload);
  },
  deleteSchedule({ commit }, payload) {
    commit(C.SCHEDULE_DELETE_PENDING);
    return xmlBook.deleteSchedule(payload).then((res) => {
      commit(C.SCHEDULE_DELETE_SUCCESS, res.data);
    }).catch(() => {
      commit(C.SCHEDULE_DELETE_FAILURE);
    });
  },
  updateSchedules({ commit }, payload) {
    commit(C.SCHEDULES_EDIT_UPDATE_PENDING);
    return xmlBook.updateSchedules(payload).then((res) => {
      commit(C.SCHEDULES_EDIT_UPDATE_SUCCESS, res.data);
    }).catch(() => {
      commit(C.SCHEDULES_EDIT_UPDATE_FAILURE);
    });
  },
  patchSchedule({ commit }, payload) {
    commit(C.SCHEDULE_PATCH_PENDING);
    return xmlBook.patchSchedule(payload).then((res) => {
      commit(C.SCHEDULE_PATCH_SUCCESS, res.data);
    }).catch((res) => {
      commit(C.SCHEDULE_PATCH_FAILURE, res.response.data.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/schedules/actions.js